export default [
    {
        icon: 'GridIcon',
        route: 'preop',
        title: 'Preop'
    },
]
